import React, { useEffect, useState } from "react";
import styles from "./Listings.module.scss";
import { PropertyCard } from "./PropertyCard/PropertyCard";
import { Header } from "../Header/Header";
import { SubHeader } from "../Overview/SubHeader/SubHeader";
import { Footer } from "../Overview/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetDocumentsByQuery } from "../Hooks/FetchHook";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

export const Listings: React.FC = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState<any>([]);
  const [order, setOrder] = useState("default");
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const propertyType = queryParams.get("propertyType");
  const location = queryParams.get("location");
  const businessType = queryParams.get("businessType");

  const { data: propertiesFetched, isLoading: isLoadingProperties } =
    useGetDocumentsByQuery("propiedad", [
      { fieldPath: "tipoDePropiedad", opStr: "==", value: propertyType },
      { fieldPath: "ciudad", opStr: "==", value: location },
      { fieldPath: "tipoDeNegocio", opStr: "==", value: businessType },
    ]);

  useEffect(() => {
    if (!isLoadingProperties && propertiesFetched) {
      setProperties(propertiesFetched);
    }
  }, [propertiesFetched, isLoadingProperties]);

  const clickRedirectFn = (propertyId: string) => {
    const params = new URLSearchParams({
      propertyId,
    }).toString();
    navigate(`/property?${params}`);
  };

  const handleOrderChange = (event: SelectChangeEvent) => {
    setOrder(event.target.value as string);
  };

  const updateSearch = (businessType: string) => {
    const params = new URLSearchParams({
      propertyType: propertyType || "",
      location: location || "",
      businessType,
    }).toString();

    navigate(`/listings?${params}`);
  };

  return (
    <>
      <div className={styles.listingsContainer}>
        <Header overviewStyle={false} />
        <SubHeader overviewStyle={false} />
        <div className={styles.banner}>
          <div className={styles.bannerContent}>
            <h1>Propiedades</h1>
            <p>Home / Properties</p>
          </div>
        </div>

        <div className={styles.contentContainer}>
          <div className={styles.tabs}>
            <button onClick={() => updateSearch("")}>
              Todas las Propiedades
            </button>
            <button onClick={() => updateSearch("Venta")}>Venta</button>
            <button onClick={() => updateSearch("Renta")}>Renta</button>
            <button onClick={() => updateSearch("Renta Vacacional")}>
              Renta vacacional
            </button>
          </div>

          <div className={styles.sorting}>
            <label htmlFor="sort">Ordenar:</label>
            <FormControl>
              <Select
                sx={{ backgroundColor: "#EFC282" }}
                labelId="type-label"
                id="type-select"
                value={order}
                label="Age"
                onChange={handleOrderChange}
              >
                <MenuItem value={"default"}>Por default</MenuItem>
                <MenuItem value={"menor"}>Precio de menor a mayor</MenuItem>
                <MenuItem value={"mayor"}>Precio de mayor a menor</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className={styles.propertyGrid}>
            {isLoadingProperties ? (
              <>Loading</>
            ) : (
              properties &&
              properties
                .sort((a: any, b: any) =>
                  order === "mayor" ? b.precio - a.precio : a.precio - b.precio
                )
                .map((property: any) => (
                  <PropertyCard
                    key={property.id}
                    property={property}
                    clickFn={clickRedirectFn}
                  />
                ))
            )}
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
};
